export const allowOnlyCoordinator = () =>
  new Promise((resolve) => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    resolve(userInfo && userInfo.data.role.includes('coordinator'))
  })
